"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTan = void 0;
var browserStorage_1 = require("@dtna/dvs-core-dcp-client-utils/lib/utils/browserStorage");
// eslint-disable-next-line import/prefer-default-export
var getTan = function () { return (0, browserStorage_1.getItemFromStorage)(browserStorage_1.localStorageKeys.TELEMATICS.TAN) || process.env.REACT_APP_USER_TAN || ''; };
exports.getTan = getTan;
